import axios from 'axios';
import { safe_client_url } from '../constants';

export const getSafe = async (chainId, safeAddr) => {
  try {
    const response = await axios.get(
      `${safe_client_url}v1/chains/${chainId}/safes/${safeAddr}`,
    );
    return response;
  } catch (e) {
    console.log(e);
    return {data: {}};
  }
};

export const getSafeTxs = async (chainId, safeAddr) => {
  try {
    const response = await axios.get(
      `${safe_client_url}v1/chains/${chainId}/safes/${safeAddr}/multisig-transactions`,
    );
    return response;
  } catch (e) {
    console.log(e);
    return { data: {results: []} };
  }
};

export const getSafeRawTxs = async (chainId, safeAddr) => {
  try {
    const response = await axios.get(
      `${safe_client_url}v1/chains/${chainId}/safes/${safeAddr}/multisig-transactions/raw`,
    );
    return response;
  } catch (e) {
    console.log(e);
    return { data: {results: []} };
  }
};

export const getSafePendingTxs = async (chainId, safeAddr) => {
  try {
    let response = await axios.get(
      `${safe_client_url}v1/chains/${chainId}/safes/${safeAddr}/multisig-transactions?executed=false`,
    );
    let results = [];
    for (let result of response.data.results) {
      if (result.transaction.txStatus !== 'CANCELLED' && !result.transaction.txInfo.isCancellation) results.push(result);
    }
    response.data.results = results;
    return response;
  } catch (e) {
    console.log(e);
    return { data: {results: []} };
  }
};

export const getSafeTxInfo = async (chainId, txId) => {
  try {
    const response = await axios.get(
      `${safe_client_url}v1/chains/${chainId}/transactions/${txId}`,
    );
    return response;
  } catch (e) {
    console.log(e);
    return { data: {} };
  }
};

export const sendProposal = async (chainId, safeAddr, proposal) => {
  try {
    const response = await axios.post(
      `${safe_client_url}v1/chains/${chainId}/transactions/${safeAddr}/propose`,
      proposal,
    );
    return response;
  } catch (e) {
    console.log(e);
    throw Error;
  }
};

export const sendConfirmation = async (
  chainId,
  safeTxHash,
  signedSafeTxHash,
) => {
  try {
    const response = await axios.post(
      `${safe_client_url}v1/chains/${chainId}/transactions/${safeTxHash}/confirmations`,
      { signedSafeTxHash },
    );
    return response;
  } catch (e) {
    console.log(e);
    throw Error;
  }
};
